import { ArrowRight, Bell, DeviceMobile, Monitor, SignIn } from '@phosphor-icons/react';
import { APP_HOST, APP_NAME } from '@shh/shared';
import { Heading, Icon, Surface, Text, buttonStyles } from '@shh/ui';
import type { Icon as PhosphorIcon } from '@phosphor-icons/react';
import { startText } from '../../i18n/start';
import { fill } from '../../i18n/fill';

const ICONS: PhosphorIcon[] = [SignIn, DeviceMobile, Monitor, Bell];
const STEPS = startText.movedSteps.map((text, i) => ({ icon: ICONS[i]!, text }));

/**
 * Shown instead of the app on the old addresses (sweethomehub.web.app …) from 1.15 on.
 * No automatic redirect: a wall display or an installed app should explain what happened
 * rather than silently land on a sign-in screen at an address the family does not know yet.
 */
export function MovedPage({ target }: { target: string }) {
  return (
    <main className="mx-auto flex min-h-dvh max-w-narrow flex-col justify-center gap-section px-safe py-section">
      <header className="flex flex-col items-start gap-gap-md">
        <img src="/icon.svg" alt="" className="size-avatar-lg rounded-card" />
        <Heading level={1} size="xl">
          {startText.moved}
        </Heading>
        <Text tone="secondary">
          {fill(startText.movedText, <strong>{APP_NAME}</strong>, <strong>{APP_HOST}</strong>)}
        </Text>
      </header>

      <a href={target} className={buttonStyles({ size: 'lg' })}>
        {startText.toNewAddress} <Icon icon={ArrowRight} size="lg" />
      </a>

      <Surface className="flex flex-col gap-gap-md">
        <Heading level={2} size="md">
          {startText.onceNeeded}
        </Heading>
        <ul className="flex flex-col gap-gap-md">
          {STEPS.map((s) => (
            <li key={s.text} className="flex items-start gap-gap-sm">
              <Icon icon={s.icon} size="md" className="mt-gap-xs shrink-0 text-text-secondary" />
              <Text>{s.text}</Text>
            </li>
          ))}
        </ul>
      </Surface>
    </main>
  );
}
